import { Box, styled } from "@mui/material";
import { primary } from "configs/colors";

export const Container = styled(Box)(() => ({
  display: "flex",
  minWidth: "100vw",
  minHeight: "100vh",
}));

export const Body = styled(Box)<{ collapsed?: boolean }>(({ collapsed }) => {
  const sidebarWidth = collapsed ? 60 : 280;
  return {
    flex: 1,
    backgroundColor: primary[700],
    paddingTop: "12px",
    marginLeft: `${sidebarWidth}px`,
    maxWidth: `calc(100vw - ${sidebarWidth}px)`,
    transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  };
});

export const Content = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: "40px 0px 0px 0px",
  padding: "32px",
  height: "100%",
}));
